import classnames from "classnames";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export function IntroItem(props) {
  // props.item
  // props.id
  // props.count
  // props.height: SignIn Page에서 사용하기 위해
  const [lines, setLines] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (!props.item?.title) return;
    setLines(props.item.title?.split("\n"));
  }, [props.item]);

  const handleClick = (e) => {
    if (!props.item.link) return;
    //TODO: 이건 임시 코드임. old vatdahm과 호환을 위해 링크를 변환한다.
    let goto = props.item.link;
    if (goto.startsWith("http")) {
      // 절대경로는 새 창으로
      window.open(goto, "_blank");
    } else {
      if (goto === "/entrance/counsel") goto = "/chat";
      else if (goto === "/introduce") goto = "/company";
      else if (goto === "/entrance/nft") goto = "/";
      else if (goto === "/login") goto = "/signin";
      navigate(goto);
    }
  };

  // const height = props.height || "18.8rem";
  const height = props.height || "301px";

  // 제일 왼쪽과 오른쪽에는 더 큰 margin을 주기 위해서, 이렇게 복잡한 조건이 걸리게 된 것임
  if (!props.item) return null;
  return (
    <div
      className={classnames(
        "border-round-lg py-3 pl-3 pr-2 flex flex-col",
        { "ml-3": props.id === 0 },
        { "ml-2": props.id !== 0 },
        { "mr-3": props.id === props.count - 1 },
        { "cursor-pointer": !!props.item?.link },
      )}
      style={{
        backgroundColor: props.item?.color,
      }}
      key={props.id}
      onClick={handleClick}
    >
      <div
        className="text-left"
        style={{ color: props.item?.fontColor, paddingTop: "0.02rem" }}
      >
        <div className="mb-0 text-lg font-bold">
          {lines.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
        <div className="text-sm mt-2">
          <span>{props.item.subTitle}</span>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center mt-3">
        <img src={props.item.imageUrl} className="max-h-[300px]" alt="signin" />
      </div>
      {props.item.link ? (
        <div
          className="absolute px-2 py-1 border-round"
          style={{
            bottom: "1rem",
            width: "4.5rem",
            backgroundColor: "rgba(0,0,0,.3)",
            color: "#f5f4f3",
          }}
        >
          Click &gt;
        </div>
      ) : null}
    </div>
  );
}
